import styled from 'styled-components';

// eslint-disable-next-line import/prefer-default-export
export const Image = styled.img`
  position: relative;
  z-index: 3;
  display: block;
  width: ${({ width }) => (width ? `${width}px` : '100%')};
  height: ${({ height }) => (height ? `${height}px` : 'auto')};
  opacity: ${({ isLoaded }) => (isLoaded ? 1 : 0)};
  transition: opacity 0.5s ease-out;
  
  ${({ isDefault }) => isDefault && `    
    background-color: #fff;
    max-height: 180px;
  `}

  ${({ isCover }) => isCover && `    
    object-fit: cover;
  `}
`;
